module.exports = __webpack_public_path__ + "media/images/lighthouse-f34fe2882afa2edbb219be4fb4516185.svg";